import { Appointments, AppointmentsDetails } from "./appointments";
import { Configuration, ConfigurationList } from "./configuration";

export {Appointments, Configuration, AppointmentsDetails, ConfigurationList}